import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=1207e335&scoped=true&"
import script from "./lists.vue?vue&type=script&lang=ts&"
export * from "./lists.vue?vue&type=script&lang=ts&"
import style0 from "./lists.vue?vue&type=style&index=0&id=1207e335&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1207e335",
  null
  
)

export default component.exports